import {
    STORAGE_KEY
} from '../common/constants';

const localStoragePlugin = store => {
    store.subscribe((mutation, state) => {
        const storedData = {
            settings: state.settings,
            user: state.user
        };

        localStorage.setItem(STORAGE_KEY, JSON.stringify(storedData));

        if (mutation.type === 'CLEAR_ALL_DATA') {
            localStorage.removeItem(STORAGE_KEY);
        }

    });
};

export default [localStoragePlugin];